import { render, staticRenderFns } from "./GrupoProdutoForm.vue?vue&type=template&id=850c5ab2"
import script from "./GrupoProdutoForm.vue?vue&type=script&lang=js"
export * from "./GrupoProdutoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports